<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">

			<div v-if="isPdf">
				<p class="arrow">
					<span @click="changePdfPage(0)" class="turn" :class="{ grey: currentPage == 1 }">Preview</span>
					{{ currentPage }} / {{ pageCount }}

					<span @click="changePdfPage(1)" class="turn" :class="{ grey: currentPage == pageCount }">Next</span>
				</p>
				<pdf :src="parameter" :page="currentPage" @num-pages="pageCount = $event"
					@page-loaded="currentPage = $event" @loaded="loadPdfHandler">
				</pdf>
			</div>
			<div v-else v-html="parameter"></div>

		</div>

		<div slot="footer">
			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import pdf from 'vue-pdf'
import constant from '@/util/constant.js';


export default {
	name: 'show',
	components: {
		popup,
		pdf
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,

			isPdf: true,
			parameter: "",
			currentPage: 0, // pdf文件页码
			pageCount: 0, // pdf文件总页数

		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			console.log(parameter);
			//是不是pdf?      /statics/attachment/null/userStroy/nlhdxjclg5rcvwowm12puxryhtzzflm.pdf
			if (parameter && parameter.substr(0, 8) == "/statics") {
				this.isPdf = true
				this.parameter = constant.serverUrl + parameter;
			} else {
				this.isPdf = false
				this.parameter = parameter;
			}

			console.log("文件", this.parameter)
			this.disabled = disabled;
			this.$refs.popup.open(title, size);

		}, changePdfPage(val) {
			// console.log(val)
			if (val === 0 && this.currentPage > 1) {
				this.currentPage--
				// console.log(this.currentPage)
			}
			if (val === 1 && this.currentPage < this.pageCount) {
				this.currentPage++
				// console.log(this.currentPage)
			}
		},

		// pdf加载时
		loadPdfHandler(e) {
			this.currentPage = 1 // 加载的时候先加载第一页
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.parameter = ""
			this.$refs.popup.close();
		},

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
